//old requestleave form

import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "../config";
import EmployeeNavbar from "../Layout/EmployeeNavbar";

const AdminFacilities = () => {
  const [form, setForm] = useState({
    leaveType: "",
    startDate: "",
    endDate: "",
    reason: "",
    document: null,
  });
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [errors, setErrors] = useState({});
  const [submitStatus, setSubmitStatus] = useState(null);
  const [leaveSummary, setLeaveSummary] = useState([]);
  const [showLOPModal, setShowLOPModal] = useState(false);
  const [lopMessage, setLopMessage] = useState("");
  const [showSwitchModal, setShowSwitchModal] = useState(false);
  const [availableLeaves, setAvailableLeaves] = useState([]);
  const navigate = useNavigate();
  const selectedColor = localStorage.getItem("empnavbarColor") || "#607799";

  const userId = localStorage.getItem("userId");


  const [navbarColor, setNavbarColor] = useState("#607799");
  localStorage.setItem("empnavbarColor", selectedColor);

  useEffect(() => {
    const savedColor = localStorage.getItem("empnavbarColor") || "#607799";
    setNavbarColor(savedColor);
  }, []);

  // ✅ Load Bootstrap
  useEffect(() => {
    const bootstrapLink = document.createElement("link");
    bootstrapLink.rel = "stylesheet";
    bootstrapLink.href =
      "https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css";
    document.head.appendChild(bootstrapLink);
    return () => bootstrapLink.remove();
  }, []);

  // ✅ Fetch leave summary
  const fetchLeaveSummary = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/");
      return;
    }
    try {
      const [typesRes, summaryRes] = await Promise.all([
        axios.get(`${API_BASE_URL}/api/leave-types/all`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
        axios.get(`${API_BASE_URL}/api/admin/leave-summary/${userId}`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
      ]);
      setLeaveTypes(typesRes.data);
      setLeaveSummary(summaryRes.data);
    } catch (err) {
      console.error("Error fetching leave summary:", err);
      if ([401, 403].includes(err.response?.status)) {
        localStorage.removeItem("token");
        navigate("/");
      }
    }
  };

  useEffect(() => {
    fetchLeaveSummary();
  }, []);

  // ✅ Form change handler
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "document") {
      setForm({ ...form, document: files[0] });
    } else {
      setForm({ ...form, [name]: value });
    }
  };

  // ✅ Calculate total days
  const calculateDaysCount = () => {
    if (!form.startDate || !form.endDate) return 0;
    const start = new Date(form.startDate);
    const end = new Date(form.endDate);
    const diff = end - start;
    return diff >= 0 ? Math.floor(diff / (1000 * 60 * 60 * 24)) + 1 : 0;
  };

  // ✅ Validation
  const validate = () => {
    const newErrors = {};
    if (!form.leaveType) newErrors.leaveType = "Leave type is required.";
    if (!form.startDate) newErrors.startDate = "Start date is required.";
    if (!form.endDate) newErrors.endDate = "End date is required.";
    if (form.startDate && form.endDate && form.endDate < form.startDate)
      newErrors.endDate = "End date cannot be before start date.";
    if (!form.reason.trim()) newErrors.reason = "Reason is required.";
    // if (form.leaveType === "Sick Leave" && !form.document)
    //   newErrors.document = "Supportive document is required for sick leave.";
    return newErrors;
  };

  // ✅ Handle Submit with smart LOP validation
  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate();
    setErrors(validationErrors);
    setSubmitStatus(null);

    if (Object.keys(validationErrors).length > 0) return;

    const requestedDays = calculateDaysCount();
    const selectedLeave = leaveSummary.find(
      (l) => l.leaveType === form.leaveType
    );

    let remaining = selectedLeave ? selectedLeave.remaining : 0;

    if (remaining >= requestedDays) {
      // Enough leave available — submit directly
      submitForm();
      return;
    }

    // Check other available leaves
    const otherAvailable = leaveSummary.filter(
      (l) => l.leaveType !== form.leaveType && l.remaining > 0
    );

    if (otherAvailable.length > 0) {
      // Suggest using other leave types first
      setAvailableLeaves(otherAvailable);
      setShowSwitchModal(true);
    } else {
      const lopDays = requestedDays - remaining;

      // ✅ AUTO-SELECT LOP
      setForm(prev => ({
        ...prev,
        leaveType: "Loss of Pay (LOP)",
      }));

      setLopMessage(
        `You do not have any credited leave left. All ${requestedDays} day(s) will be considered Loss of Pay (LOP).`
      );

      setShowLOPModal(true);
    }

  };

  // ✅ Final submission
  const submitForm = async () => {
    try {
      const token = localStorage.getItem("token");
      const formData = new FormData();
      formData.append("leaveType", form.leaveType);
      formData.append("startDate", form.startDate);
      formData.append("endDate", form.endDate);
      formData.append("reason", form.reason);
      if (form.document) formData.append("document", form.document);

      await axios.post(`${API_BASE_URL}/api/leaves/create`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      setSubmitStatus("success");
      await fetchLeaveSummary();
      setTimeout(() => navigate("/allleaves"), 1000);
    } catch (error) {
      console.error(error);
      if ([401, 403].includes(error.response?.status)) {
        localStorage.removeItem("token");
        navigate("/");
      }
      setSubmitStatus("error");
    }
  };



  return (
    <>
      <div className="fixed-top">
        <EmployeeNavbar />
      </div>

      <div
        className="d-flex flex-column"
        style={{ height: "100vh", backgroundColor: "#f8f9fa", paddingTop: "120px" }}
      >
        <div className="flex-grow-1 overflow-auto px-5 py-4 ">

          {/* ===== Compact Summary Box (Right aligned) ===== */}
          <div className="d-flex justify-content-end mb-3">
            <div
              className="card shadow-sm border-0 rounded-3"
              style={{ width: "305px" }}
            >
              <div className="card-body p-2">
                {/* Header */}
                <h6
                  className="fw-semibold mb-2 text-start"
                  style={{ fontSize: "0.9rem", background: "#DFE4EB", padding: "4px", borderRadius: "4px" }}
                >
                  Summary
                </h6>

                {/* Leave rows */}
                {leaveSummary.length === 0 ? (
                  <div className="text-center" style={{ fontSize: "0.85rem" }}>
                    No leave records found.
                  </div>
                ) : (
                  leaveSummary.map((leave) => (
                    <div
                      key={leave.leaveType}
                      className="d-flex justify-content-between mb-1"
                      style={{ fontSize: "0.85rem", padding: "0 8px" }}
                    >
                      <span>{leave.leaveType}</span>
                      <span>
                        {leave.remaining} [ {leave.applied} ]
                      </span>
                    </div>
                  ))
                )}

                {/* Total row */}
                {leaveSummary.length > 0 && (
                  <div
                    className="d-flex justify-content-between fw-semibold border-top pt-1 mt-1"
                    style={{ fontSize: "0.85rem", padding: "0 8px" }}
                  >
                    <span>Total</span>
                    <span>
                      {leaveSummary.reduce((sum, l) => sum + l.remaining, 0)} [ {" "}
                      {leaveSummary.reduce((sum, l) => sum + l.applied, 0)} ]
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>



          {/* ===== Leave Form Card ===== */}
          <div className="card shadow-sm border-0 rounded-3">
            <div className="card-header bg-white border-bottom d-flex justify-content-between align-items-center">
              <h5 className="fw-semibold mb-0">Leave Application</h5>
              <span
                style={{ cursor: "pointer", color: "#007bff" }}
                onClick={() => navigate("/allleaves")}
              >
                List
              </span>
            </div>

            <div className="card-body p-4">
              {submitStatus === "success" && (
                <div className="alert alert-success text-center mb-4">
                  ✅ Leave Application submitted successfully! Redirecting...
                </div>
              )}
              {submitStatus === "error" && (
                <div className="alert alert-danger text-center mb-4">
                  ❌ Something went wrong. Please try again.
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="row g-4">
                  {/* Leave Type */}
                  <div className="col-md-4">
                    <label className="form-label">Leave Type</label>
                    <select
                      name="leaveType"
                      value={form.leaveType}
                      onChange={handleChange}
                      className={`form-select ${errors.leaveType ? "is-invalid" : ""
                        }`}
                    >
                      <option value="">Select Type</option>
                      {leaveTypes.map((type) => (
                        <option key={type.id} value={type.name}>
                          {type.name}
                        </option>
                      ))}
                    </select>
                    <div className="invalid-feedback">{errors.leaveType}</div>
                  </div>

                  {/* Start Date */}
                  <div className="col-md-4">
                    <label className="form-label">Start Date</label>
                    <input
                      type="date"
                      name="startDate"
                      value={form.startDate}
                      onChange={handleChange}
                      min={new Date().toISOString().split("T")[0]}
                      className={`form-control ${errors.startDate ? "is-invalid" : ""
                        }`}
                    />
                    <div className="invalid-feedback">{errors.startDate}</div>
                  </div>

                  {/* End Date */}
                  <div className="col-md-4">
                    <label className="form-label">End Date</label>
                    <input
                      type="date"
                      name="endDate"
                      value={form.endDate}
                      onChange={handleChange}
                      min={form.startDate || new Date().toISOString().split("T")[0]}
                      className={`form-control ${errors.endDate ? "is-invalid" : ""}`}
                    />
                    <div className="invalid-feedback">{errors.endDate}</div>
                  </div>

                  {/* Reason */}
                  <div className="col-md-6">
                    <label className="form-label">Reason</label>
                    <textarea
                      name="reason"
                      value={form.reason}
                      onChange={handleChange}
                      className={`form-control ${errors.reason ? "is-invalid" : ""}`}
                      rows={4}
                      placeholder="Write your reason here..."
                    />
                    <div className="invalid-feedback">{errors.reason}</div>
                  </div>

                  {/* Supportive Document */}
                  {form.leaveType === "Sick Leave" && (
                    <div className="col-md-6">
                      <label className="form-label">Supportive Document</label>
                      <input
                        type="file"
                        name="document"
                        onChange={handleChange}
                        className={`form-control ${errors.document ? "is-invalid" : ""}`}
                      />
                      <div className="invalid-feedback">{errors.document}</div>
                    </div>
                  )}

                  {/* Total Days */}
                  {form.startDate && form.endDate && (
                    <div className="col-12">
                      <p className="mb-0">
                        📅 Total Days: <strong>{calculateDaysCount()}</strong>
                      </p>
                    </div>
                  )}

                  {/* Buttons */}
                  <div className="col-12 d-flex justify-content-start gap-3">
                    <button type="submit" className="btn btn-primary btn-sm px-3">
                      Submit
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary btn-sm px-3"
                      onClick={() => navigate(-1)}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* ===== Alternative Leave Modal ===== */}
        {showSwitchModal && (
          <div className="modal fade show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: selectedColor, color: "rgba(253, 252, 252, 1)" }}>

                  <h5 className="modal-title">Choose an Alternative Leave Type</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowSwitchModal(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  <p>
                    You don’t have enough <strong>{form.leaveType}</strong> balance.
                    You still have remaining balance in other leave types.
                    Please select one below:
                  </p>
                  <ul className="list-group">
                    {availableLeaves.map((l) => (
                      <li
                        key={l.leaveType}
                        className="list-group-item list-group-item-action"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setForm({ ...form, leaveType: l.leaveType });
                          setShowSwitchModal(false);
                        }}
                      >
                        <strong>{l.leaveType}</strong> — {l.remaining} days left
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setShowSwitchModal(false)}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => {
                      setForm((prev) => ({
                        ...prev,
                        leaveType: "Loss of Pay (LOP)",
                      }));
                      setShowSwitchModal(false);
                      setShowLOPModal(true);
                    }}
                  >
                    Proceed with LOP anyway
                  </button>

                </div>
              </div>
            </div>
          </div>
        )}

        {/* ===== LOP Modal ===== */}
        {showLOPModal && (
          <div className="modal fade show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: selectedColor, color: "rgba(253, 252, 252, 1)" }}>

                  <h5 className="modal-title">Loss of Pay Alert</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowLOPModal(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  <p>{lopMessage}</p>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setShowLOPModal(false)}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => {
                      setShowLOPModal(false);
                      submitForm();
                    }}
                  >
                    Proceed with LOP
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

      </div>
    </>
  );
};

export default AdminFacilities;
